// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nothing-found {\n  padding: 20px;\n  font-style: italic;\n  display: block;\n}", "",{"version":3,"sources":["webpack://./src/pages/Home/NotingFound/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,cAAA;AACF","sourcesContent":[".nothing-found {\n  padding: 20px;\n  font-style: italic;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
